import "./Checkbox.scss";

const Checkbox = ({
  children,
  isChecked = false,
  name,
  id,
  color = "#19ae57",
  ref,
  className = "",
  labelClassName = "",
  ...props
}) => {
  const onChange = () => {
    props?.onChange(!isChecked);
  };

  return (
    <label
      htmlFor={id}
      className={`${children ? "d-flex" : ""} align-items-center cursor-pointer ${labelClassName}`}
      style={{ gap: "5px" }}
    >
      <span
        className={`checkbox mr-4 ${className}`}
        style={{ "--checkbox-color": color }}
      >
        <input
          {...props}
          ref={ref}
          name={name}
          type="checkbox"
          id={id}
          checked={isChecked}
          onChange={onChange}
        />
        <label htmlFor={id}></label>
      </span>

      {children ? <span htmlFor={id}>{children}</span> : null}
    </label>
  );
};

export default Checkbox;
